module.exports = __webpack_public_path__ + "static/media/shop-shoes.d3fab257.png";